// extracted by mini-css-extract-plugin
export default {"link":"pageLanguageLink_link__YWY8E","icon":"pageLanguageLink_icon__-KSrU"};